import React, { useEffect, useState, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Grid, MenuItem, TextField, Typography, CardContent, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useHistory, useLocation, useNavigate } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import LoaderCircular from 'ui-component/LoaderCircular';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { fetchReportDataForNonSkanReporting } from '../../redux/reporting/reportingActions';
import { getDynamicColumns } from '../../utils/dynamicColumns';
import '../Dashboard/styleSearch.scss';
import ScrollIndicator from '../scroller/ScrollIndicator';
const columns = [
  // { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'campaign_name',
    headerName: 'Campaign Name',
    flex: 2,
    minWidth: 200,
    renderCell: (params) => <div className="campaign_name_settings">{params.value}</div>
  },
  // {
  //   field: "event_name",
  //   headerName: "Event Name",
  // },
  {
    field: 'publisher_app_name',
    headerName: 'Publisher App Name',
    width: 180,
    renderCell: (params) => {
      const value = params.value?.trim();
      const isUnknown = !value || value.toLowerCase() === 'unknown';
      const displayValue = isUnknown ? '-' : value;
      return (
        <div
          className="campaign_name_settings"
          style={{
            textAlign: isUnknown ? 'center' : 'left', // center only for '-'
            width: '100%'
          }}
        >
          {displayValue}
        </div>
      );
    }
  },
  {
    field: 'app_bundle',
    headerName: 'App Bundle',
    flex: 1,
    minWidth: 120,
    renderCell: (params) => <div className="campaign_name_settings">{params.value}</div>
  },
  {
    field: 'country',
    headerName: 'Country',
    flex: 0.8,
    minWidth: 100
    // align: 'center',
    // headerAlign: 'center'
  },
  {
    field: 'os_name',
    headerName: 'OS',
    flex: 0.6,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'clicks',
    headerName: 'Clicks',
    valueFormatter: (params) => splitDigits(params.value),
    flex: 1,
    minWidth: 100,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'impressions',
    headerName: 'Impressions',
    valueFormatter: (params) => splitDigits(params.value),
    flex: 1,
    minWidth: 120,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'media_cost',
    headerName: 'Media Cost ($)',
    valueFormatter: (params) => splitDigits(roundToTwoDecimal(params.value)),
    flex: 1,
    minWidth: 140,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'media_cost_local_currency',
    headerName: 'Media Cost (¥)',
    valueFormatter: (params) => splitDigits(roundYen(params.value)),
    flex: 1,
    minWidth: 140,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'installs',
    headerName: 'Installs',
    sort: 'desc',
    flex: 1,
    minWidth: 100,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'kpi_event_count',
    headerName: 'Kpi Event Count',
    sort: 'desc',
    flex: 1,
    minWidth: 120,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ctr',
    headerName: 'CTR',
    valueFormatter: (params) => roundToTwoDecimalPercent(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpm',
    headerName: 'eCPM ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpm_local',
    headerName: 'eCPM (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpc',
    headerName: 'eCPC ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpc_local',
    headerName: 'eCPC (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpi',
    headerName: 'eCPI ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpi_local',
    headerName: 'eCPI (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpe',
    headerName: 'eCPE ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpe_local',
    headerName: 'eCPE (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  }
  // {
  //   field: 'Country',
  //   headerName: 'Country',
  //   description: 'This column has a value getter and is not sortable.',
  //   sortable: false,
  //   width: 160,
  //   valueGetter: (params) =>
  //     `${params.row.firstName || ''} ${params.row.lastName || ''}`,
  // },
];
function splitDigits(num) {
  return Number(num).toLocaleString();
}
function roundToTwoDecimal(value) {
  if (value == '-999') return '-';
  // return Math.round((value + Number.EPSILON) * 100) / 100;
  return (Math.round((value + Number.EPSILON) * 10000) / 10000).toFixed(4);
}
function roundYen(value) {
  if (value == '-999') return '-';
  return Math.round(value);
}
function roundToTwoDecimalPercent(value) {
  if (value == '-999') return '-';
  // const roundedValue = Math.round((value * 100 + Number.EPSILON) * 100) / 100; // Multiply by 100 to convert to percentage
  // return `${roundedValue}%`; // Append '%' sign
  const roundedValue = Math.round((value * 100 + Number.EPSILON) * 10000) / 10000;
  return `${roundedValue.toFixed(4)}%`;
}
const ReportDataNonSkanView = ({ reportingData, loading, campaign_list, isSkan, end_date, start_date, error, timeZone, isDollar }) => {
  const location = useLocation();
  let currentPath = location.pathname.split('/')[1];
  const gridContainerRef = useRef(null);
  // console.log(currentPath);
  useEffect(() => {
    //fetchDataForReportingDatatable();
    // fetchReportData()
    if (campaign_list.length > 0) {
      //console.log(campaign_list)
      //let campaignIds=campaign_list.map(value=>value.campaignGuid)
      //fetchReportData(campaign_list)
    }
  }, [campaign_list, isSkan, end_date, start_date]);

  // console.log(reportingData.length);
  const getRowHeight = (params) => {
    const column2Value = params.model.campaign_name;
    //console.log(column2Value);
    if (column2Value.length > 110) {
      return 150; // Return the desired row height in pixels
    } else if (column2Value.length > 100) {
      return 130; // Return the desired row height in pixels
    } else {
      return 50;
    }
  };
  const columnVisibilityModel = React.useMemo(() => {
    if (timeZone == 'JST' && isDollar == true) {
      return {
        media_cost_local_currency: false,
        media_cost: true,
        ecpc_local: false,
        ecpc: true,
        ecpm_local: false,
        ecpm: true,
        ecpi_local: false,
        ecpi: true,
        ecpe_local: false,
        ecpe: true,
      };
    } else if (timeZone == 'JST' && isDollar == false) {
      return {
        media_cost_local_currency: true,
        media_cost: false,
        ecpc_local: true,
        ecpc: false,
        ecpm_local: true,
        ecpm: false,
        ecpi_local: true,
        ecpi: false,
        ecpe_local: true,
        ecpe: false,
      };
    } else {
      return {
        media_cost_local_currency: false,
        media_cost: true,
        ecpc_local: false,
        ecpc: true,
        ecpm_local: false,
        ecpm: true,
        ecpi_local: false,
        ecpi: true,
        ecpe_local: false,
        ecpe: true,
      };
    }
  }, [timeZone, isDollar]);

  // Get dynamic columns based on available data
  const dynamicColumns = useMemo(() => {
    return getDynamicColumns(columns, reportingData);
  }, [reportingData]);
  //console.log("cc",campaign_list,loading,advertiser_campaign_fetching)
  return (
    <>
      {loading ? (
        <MainCard>
          <Grid container spacing={gridSpacing}>
            <Grid item lg={12} md={12} sm={12} xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <Typography variant="h4">Top 500 Publisher Apps Report</Typography>
            </Grid>

            <Grid item xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <div style={{ height: '200px', width: '100%' }}>
                {' '}
                <LoaderCircular show={true} />
              </div>
            </Grid>
          </Grid>
        </MainCard>
      ) : reportingData == 0 || campaign_list.length == 0 ? (
        <MainCard>
          <Grid container spacing={gridSpacing}>
            <Grid item lg={12} md={12} sm={12} xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <Typography variant="h4">Top 500 Publisher Apps Report</Typography>
            </Grid>

            <Grid item xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <Typography style={{ textAlign: 'center' }}>
                {/* Please click <b>Apply Filter</b> to view data */}
                {error.length != 0 ? (
                  'No Data Found'
                ) : (
                  <span>
                    Please click <b>Apply Filter</b> to view data
                  </span>
                )}
              </Typography>
            </Grid>
          </Grid>
        </MainCard>
      ) : (
        <MainCard>
          <Grid container spacing={gridSpacing}>
            <Grid item lg={12} md={12} sm={12} xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <Typography variant="h4">Top 500 Publisher Apps Report</Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container alignItems="center" justifyContent="space-between">
                <Grid item xs={12}>
                  <Box sx={{ position: 'relative' }}>
                    {/* new scroll option for report view */}
                    <div
                      ref={gridContainerRef}
                      style={{
                        width: '100%',
                        position: 'relative',
                        overflowX: 'auto',
                        overflowY: 'hidden'
                      }}
                    >
                      <style>
                        {`
                          .custom-datagrid {
                            width: 100% !important;
                          }
                          .custom-datagrid .MuiDataGrid-main {
                            width: 100% !important;
                          }
                          .custom-datagrid .MuiDataGrid-virtualScroller {
                            width: 100% !important;
                          }
                        `}
                      </style>
                      <ScrollIndicator containerRef={gridContainerRef} />
                      {loading ? (
                        <CircularProgress
                          style={{
                            position: 'relative',
                            top: '50%',
                            left: '50%'
                          }}
                        />
                      ) : (
                        <DataGrid
                          rows={reportingData}
                          columns={dynamicColumns}
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 10
                              }
                            },
                            sorting: {
                              sortModel: [{ field: 'media_cost', sort: 'desc' }] // Default sort on 'cost' column
                            }
                          }}
                          components={{
                            LoadingOverlay: CircularProgress
                          }}
                          loading={loading}
                          pageSizeOptions={[10, 20, 30]}
                          slots={{ toolbar: GridToolbar }}
                          disableRowSelectionOnClick
                          disableColumnSelector
                          disableDensitySelector
                          // style={{ minHeight: "400px", width: "100%" }}
                          // style={{ minHeight: '100%', width: '100%', minWidth: '1200px' }}
                          columnVisibilityModel={columnVisibilityModel}
                          autoHeight
                          // getRowHeight={getRowHeight}
                          getRowHeight={() => 'auto'}
                          className="custom-datagrid"
                        />
                      )}
                    </div>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MainCard>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    reportingData: state.reportingReducer.reportingData,
    loading: state.reportingReducer.bundleReportLoading,
    campaign_list: state.advertiserReducer.selected_campaigns,
    isSkan: state.campaignReducer.isSkan,
    end_date: state.campaignReducer.end_date,
    start_date: state.campaignReducer.start_date,
    advertiser_campaign_fetching: state.advertiserReducer.advertiser_campaign_fetching,
    error: state.reportingReducer.error,
    timeZone: state.advertiserReducer.timeZone,
    isDollar: state.campaignReducer.isDollar
  };
};
const mapDispatchToProps = {
  fetchReportDataForNonSkanReporting: fetchReportDataForNonSkanReporting
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportDataNonSkanView);
